import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Create from "./CreatePhysicalAddress";

export class AddContact extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired
  };

  state = {
    open: false
  };

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  render() {
    const { id } = this.props;
    const { open } = this.state;

    return (
      <div className="btn-group pull-right">
        <button onClick={this.open} className="btn btn-primary btn-hollow">
          <i className="fa fa-fw fa-plus" />
          Add Physical Address
          <Create id={id} open={open} close={this.close} />
        </button>
      </div>
    );
  }
}

export default connect(state => ({
  id: state.companyDetail.getIn(["company", "id"])
}))(AddContact);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/PhysicalAddresses/Create/NewPhysicalAddress.jsx